import React, {useContext, useEffect, useState} from "react";
import {OrganizationServiceContext} from "../../Contexts";
import Organization from "../../domain/Organization";
import QueryOptions from "../../sal-ui/QueryOptions";
import {FilterItem, FilterItemProps, SelectEditor} from "../tablefilter/TableFilter";
import {SearchFilter} from "../tablefilter/SearchFilter";

interface OrganizationItemProps extends FilterItemProps {
    organizations?: Organization[];
}

function OrganizationItem(props: OrganizationItemProps) {
    return (
        <SelectEditor
            width={180}
            multiple={true}
            showSearch={true}
            optionFilterProp="label"
            options={props.organizations?.map(organization => ({
                value: organization.id,
                label: organization.name
            }))}
            value={props.value}
            onChange={value => props.onChange(value)}
        />
    );
}

interface InterestFilterProps {
    className?: string;
    values?: any;
    persistentStateIdent?: string;
    onChange: (values: any) => void;
}

export function createDefaultInterestFilterValues() {
    return {organizationIds: []};
}

function InterestFilter(props: InterestFilterProps) {
    const organizationService = useContext(OrganizationServiceContext);
    const [organizations, setOrganizations] = useState<Organization[]>();

    useEffect(() => {
        organizationService.getList(QueryOptions.newUnlimitedOrderedInstance("name"))
            .then(result => setOrganizations(result.data));
    }, [organizationService]);

    const items: FilterItem[] = [
        {
            name: "organizationIds",
            key: "organizationIds",
            label: "Organization",
            render: itemProps => <OrganizationItem {...itemProps} organizations={organizations}/>
        }
    ];

    return (
        <SearchFilter
            items={items}
            className={props.className}
            values={props.values}
            defaultValues={createDefaultInterestFilterValues()}
            persistentStateIdent={props.persistentStateIdent}
            defaultActiveFilterNames={["organizationIds"]}
            onChange={props.onChange}
        />
    );
}

export default InterestFilter;
